import noop from 'lodash/noop';
import TransitionScreenLegacyDialog from '@atlassian/jira-common-components-transition-screen-legacy-dialog';
import { timeToRenderTransitionModal } from '@atlassian/jira-common-components-transition-screen-legacy-dialog/src/transition-modal-performance-analytics';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { ff } from '@atlassian/jira-feature-flagging';
import type { Actions } from '../../../common/types';
import { startIssueTransitionMetrics } from '../../../common/ui';
import { isNewTransitionScreenEnabled } from '../../../common/utils';

const openIssueTransitionModal: Actions['openIssueTransitionModal'] =
	(nextState, preferNewIssueTransitionScreen = true) =>
	({ setState, getState }) => {
		const currentState = getState();

		const {
			payload: { issueKey = '', transitionId = '' },
			onDialogSuccess,
			onDialogCancel,
			onDialogError,
			triggerPointKey,
		} = nextState || {
			payload: {},
		};
		let transitionModalVersion = '';
		const isNewITSEnabled = isNewTransitionScreenEnabled(
			preferNewIssueTransitionScreen,
			triggerPointKey,
		);
		try {
			if (isNewITSEnabled) {
				transitionModalVersion = 'NEW';
				startIssueTransitionMetrics(currentState.isSubsequentLoad);
				if (ff('modernised-issue-transition-iframe-apps-fix_mlwcn')) {
					const parentWindow = window.parent;
					const topWindow = window.top;

					// ? Compare topWindow and parentWindow to check if the current window is in an iframe
					// ? ref: https://developer.mozilla.org/en-US/docs/Web/API/Window/parent
					if (parentWindow !== topWindow) {
						parentWindow.postMessage({
							event: 'openIssueTransitionModal',
							payload: {
								payload: nextState?.payload,
								triggerPointKey,
							},
						});
					} else {
						setState({
							...currentState,
							isModalOpen: true,
							// making fetchedIssueId as blank to ensure we donot end up using stale issueId
							fetchedIssueId: '',
							...nextState,
						});
					}
					// TODO cleanup else block after removing the ff('modernised-issue-transition-iframe-apps-fix_mlwcn')
				} else {
					setState({
						...currentState,
						isModalOpen: true,
						// making fetchedIssueId as blank to ensure we donot end up using stale issueId
						fetchedIssueId: '',
						...nextState,
					});
				}
			} else {
				transitionModalVersion = 'OLD';
				timeToRenderTransitionModal.start();
				new TransitionScreenLegacyDialog({
					issueKey,
					transitionId,
				})
					.onDialogSuccess(onDialogSuccess || noop)
					.onDialogCancel(onDialogCancel || noop)
					.onDialogError(onDialogError || noop)
					.show();
			}
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				meta: {
					id: 'transitionIssueTrigger',
					packageName: 'jiraIssueTransitionTrigger',
					teamName: 'gryffindor',
				},
				error,
				attributes: {
					transitionModalVersion,
				},
				sendToPrivacyUnsafeSplunk: true,
			});
			throw error;
		}
	};

export default openIssueTransitionModal;
